import React from 'react'
import { LoanBonusCalculator } from '@shared/components/bonus-calculator'
import { Button } from '@shared/components/button'
import { scrollToApplicationForm } from '@shared/components/forms/application/cross-new'
import { Section } from '@shared/components/section'
import { useScreenSize } from '@shared/hooks/use-screen-size'
import cx from 'classnames'

import { StateProps } from './model'

import styles from './style.module.scss'

const LoanButton = () => (
	<Button className={styles.button} onClick={scrollToApplicationForm}>
		Оставить заявку
	</Button>
)

export const View = ({ sectionProps }: StateProps) => {
	const { isMobile, isExtraMobile } = useScreenSize()
	const showInMobile = isMobile || isExtraMobile

	return (
		<Section fullWidth {...sectionProps} className={cx(styles.wrapper, sectionProps?.className)}>
			<div className={styles.content}>
				<div>
					<h2 className={styles.title}>
						Начислим приятный денежный бонус сразу после оформления кредита
					</h2>
					{!showInMobile && <LoanButton />}
				</div>
				<div className={styles.calculator}>
					<LoanBonusCalculator />
				</div>
				{showInMobile && <LoanButton />}
			</div>
		</Section>
	)
}
